/* eslint-disable react/no-find-dom-node */

import { OrderType } from "../../../../Wrap/Constants/Enums/Domain/OrderType";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { IValidatable } from "../../../../react-core/Html/Validation/IValidatable";

export interface IProcessComponentProps {
    data: any;
    onChange: Function;
    onRef: (ref) => void;
    isReview?: boolean;
    readonly?: boolean;
    isDisableNextBtn?: boolean;
    showErrorMsgPopUp?: (msg: string[], showNow?: boolean) => void;
    orderType?: OrderType;
    onOrderTypeChange?: (value) => void;
}

export abstract class ProcessComponent<TProps extends IProcessComponentProps, TState>
    extends FormComponent<TProps, TState>
    implements IValidatable {
    constructor(props: TProps) {
        super(props);
    }
    private child = [];

    public abstract render(): JSX.Element;

    componentDidUpdate(prevProps) {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
        if (!CommonHelper.isNullOrEmpty(this.props.isReview) && this.props.isReview) {
            this.setDisable();
            this.disableBtn();
        } else if (!CommonHelper.isNullOrEmpty(this.props.readonly) && this.props.readonly) {
            this.setDisable();
            if (this.props.isDisableNextBtn) {
                this.disableBtn();
            }
        }
    }

    componentWillUpdate(nextProps, nextStat) {
        this.child = [];
    }

    private onRef(callback) {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
        if (callback) {callback();}
    }

    public getChild(index: number) {
        return this.child[index] || null;
    }

    public onDataChange(onChange, changes, data, key?) {
        let _data = JSON.parse(JSON.stringify(data || {}));

        _data = _data[key] || {};

        if (Array.isArray(changes)) {
            _data = JSON.parse(JSON.stringify(changes));
        }
        else {
            for (const item in changes) {
                _data[item] = JSON.parse(JSON.stringify(changes[item]));
            }
        }
   
        if (key) {
            onChange({ [key]: _data });
        } else {
            onChange(_data);
        }
    }

    public appendChild(ref, index?: number) {
        if (!CommonHelper.isNullOrEmpty(index)) {
            this.child[index] = ref;
        } else {
            this.child.push(ref);
        }
    }

    public clearChild() {
        this.child = [];
    }

    public isValidChild(index) {
        if (!this.child[index]) {
            console.warn("children is not exist!");
            return;
        }
        return this.child[index].isValid();
    }

    componentDidMount() {
        this.onRef(() => {
            if (this.props.isReview) {
                this.setDisable();
                this.disableBtn();
            } else if (this.props.readonly) {
                this.setDisable();
                if (this.props.isDisableNextBtn) {
                    this.disableBtn();
                }
            }
        });
    }

    private disableBtn() {
        const buttonLen = document.getElementsByTagName("button").length;
        for (let i = 0; i < buttonLen; i++) {
            const btn = document.getElementsByTagName("button").item(i);
            if (
                (!this.props.isDisableNextBtn && !btn.parentElement.className.includes("action-secondary") &&
                    !btn.parentElement.className.includes("action-primary") &&
                    !btn.parentElement.className.includes("left-side") &&
                    !btn.parentElement.className.includes("right-side") &&
                    !btn.className.includes("download-button")) || (this.props.isDisableNextBtn && btn.innerText.startsWith('Next'))
            ) {
                document.getElementsByTagName("button").item(i).disabled = true;
                document.getElementsByTagName("button").item(i).onclick = null;
                document.getElementsByTagName("button").item(i).style.pointerEvents = "none";
            }
        }
    }

    public setDisable() {
        super.setDisable();
        const child = this.child.concat();
        child.reverse().forEach((element) => {
            if (element?.props?.readonly !== false) {
                element.setDisable();
            }
        });
    }

    public isValid(): boolean {
        let flag = super.isValid();
        const child = this.child.concat();
        child.reverse().forEach((element) => {
            const isValid = element.isValid();
            if (!isValid) {flag = false;}
        });
        return flag;
    }
}
